import { render } from "./govbatchmaster.vue?vue&type=template&id=71b611aa&scoped=true"
import script from "./govbatchmaster.vue?vue&type=script&lang=js"
export * from "./govbatchmaster.vue?vue&type=script&lang=js"

import "./govbatchmaster.vue?vue&type=style&index=0&id=71b611aa&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b611aa"]])

export default __exports__